import { Ellipsis } from "antd-mobile";
import { CloseCircleFill } from "antd-mobile-icons";
import SquareImg from "components/dot/img/square-img";
import { useI18n } from "i18n/useI18n";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PostsDataType } from "services/apis/cnt2/post-api";

import { removeItem as removeCollectItem } from "stores/collectSlice";
import { removeItem as removeHistoryItem } from "stores/historySlice";
import { addRemoveList } from "stores/removeListSlice";

export type CellTidyDataType = {
  postUuid: string;
  postTitle: string;
  postCover: string;
  postSourceType: string;
  termUuid: string;
  isCollect: boolean;
  isRemove: boolean;
  showMask: boolean;
  handleRemove?: () => {};
};

export type CustomParaType = {
  dispatch: any;
  removeList: any;
};

const CellTidy = (props: CellTidyDataType) => {
  const { t } = useI18n();
  const dispatch = useDispatch();
  const removeList = useSelector((state: any) => state.removeListHandle.value);
  const navigate = useNavigate();

  return (
    <>
      {!props.isRemove && (
        <>
          <div
            style={{
              color: "#fff",
              borderRadius: 10,
            }}
            className=" text-white"
            // TODO: BUG 跳转后 接受的state为null
            onClick={() => {
              if (props.showMask) {
                return;
              }
              const _state = {
                postUuid: props.postUuid,
                postTitle: props.postTitle,
                postCoverUrlList: [props.postCover],
                postSourceType: props.postSourceType,
              };
              // console.log(_state, item);
              navigate("/detail", {
                state: { post: _state as PostsDataType, term: { termUuid: props.termUuid } },
              });
            }}
          >
            <div key={props.postUuid} className=" relative">
              {/* 帖子封面 */}
              <div className=" bg-black overflow-hidden rounded-2xl">
                <SquareImg
                  src={props.postCover}
                  style={{
                    opacity: props.showMask ? 0.3 : 1,
                  }}
                />
              </div>
              {/* 移除按钮 */}
              {props.showMask && (
                <>
                  <div
                    style={{
                      color: "#f55",
                      borderRadius: 8,
                      opacity: 0.85,
                      fontSize: 12,
                      fontWeight: "bolder",
                      position: "absolute", // 使元素脱离文档流，可以精确控制其位置
                      top: "50%", // 将元素的左上角定位到父容器的中心
                      left: "50%",
                      transform: "translate(-50%, -50%)", // 将元素向左和向上移动自身宽度和高度的一半，从而实现精确的水平和垂直居中
                    }}
                    onClick={(e) => {
                      //图形界面隐藏移除的视频
                      if (props.isCollect) {
                        dispatch(removeCollectItem(props.postUuid));
                      } else {
                        dispatch(removeHistoryItem(props.postUuid));
                      }
                      //把视频放入移除列表
                      dispatch(addRemoveList(props.postUuid));
                      e.preventDefault();
                      return;
                    }}
                  >
                    <div>
                      <CloseCircleFill style={{ fontSize: "500%" }} />
                    </div>
                    <p style={{ margin: "2%", fontSize: 14, textWrap: "nowrap" }}>{t("cell-tidy.index.180776-0")}</p>
                  </div>
                </>
              )}
            </div>
            <div style={{ padding: "10px 0px", color: "#333" }}>
              <Ellipsis rows={3} style={{ textAlign: "left" }} content={props.postTitle} />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default CellTidy;
